import { v4 as uuidv4 } from 'uuid'
import { BaseModel } from './BaseModel'

// 把身份证正反面拆分到两个数组中
function parseIdPicList(picList) {
  return picList.sort((a, b) => a.idCardType > b.idCardType)
}

export class PersonalInfo {
  name = ''
  email = ''
  postalCode = ''
  address = ''
  idNum = ''
  phoneNum = ''
  idPicList = []
  idPicList1 = [] // 正面
  idPicList2 = [] // 反面
  agentList = undefined

  constructor(isAgent) {
    this.agentList = isAgent ? [] : undefined
  }
}

export class CompanyInfo {
  companyName = ''
  liaison = ''
  address = ''
  email = ''
  postalCode = ''
  phoneNum = ''
  licenseList = []
  agentList = undefined

  constructor(isAgent) {
    this.agentList = isAgent ? [] : undefined
  }
}

/* ============= CpNotice ============= */
export class CpNotice extends BaseModel {
  id = null
  appealId = null // 子单关联父单ID
  musicName = '' // 音乐名称
  singerName = '' // 歌手名称
  claimTime = void (0) // 认领时间
  claimCompanyName = '' // 版权(授权)方
  displayCompanyName = '' // 外显公司
  authArea = '' // 授权区域
  isOnly = 0 // 是否首发
  onlyDuration = 0 // 首发天数
  onlinePlat = 1 // 上线平台
  contract = '' // 合约归属
  isPay = 0 // 是否进付费包
  canLegalRights = 0 // 是否可维权
  trackCount = 0 // 歌曲数量
  kTrackCount = 0 // 伴奏数量
  mvCount = 0 // MV数量
  authType = 0 // 授权类型
  isMonitor = 0 // 人工监控
  remarks = '' // 备注
  fileUrl = '' // 汇总文件链接
  fileName = '' // 汇总文件名
  appealRightFileList = [] // 认领权利文件列表
  baiduUrl = '' // 百度网盘链接+密码

  fileList = [] // 汇总文件列表

  rightFileType = 1

  constructor(initObj) {
    super()

    this._collectProperties()
    if (initObj) {
      this._setValues(initObj)
      this.init(initObj)
    }
  }

  init(initObj) {
    super.init(initObj)

    // 把汇总文件链接和文件名处理成列表
    if (initObj.fileUrl) {
      this.fileList = [{
        url: initObj.fileUrl,
        name: initObj.fileName
      }]
    }

    if (!this.baiduUrl && this.appealRightFileList.length) {
      this.rightFileType = 2
    }
  }

  getBackendData() {
    const postData = super.getBackendData()

    if (postData.fileList.length) {
      postData.fileUrl = postData.fileList[0].url
      postData.fileName = postData.fileList[0].name
    }

    return postData
  }
}

/* ============= Complaint ============= */
export class Complaint extends BaseModel {
  id = null
  appealTitle = '' // 工单名
  createUser = '' // 提单人
  appealType = 0 // 投诉方类型：枚举值：0 个人、 1 公司、2 厂牌、3 用户、4 竞品、5 组织、6 内部自查
  appealName = '' // 投诉方名称
  bussType = 0 // 业务类型：0、侵权投诉、1、下架申请、2、白名单保护
  highType = 0 // 高危类型：0、无、1、涉诉、2、应用商店/渠道投诉、3、3.0、4、网易屏蔽/独家
  complaintType = 0 // 侵权类型：0、无、1、盗版、2、盗歌、3、翻唱
  reviewStatus = 0 // 审核状态：0、草稿、1、身份待认证、2、待审核、3、未通过、4、受理中、5、处置中、6、已完成
  remark = ''
  appealFileLevel = 0 // 申诉文件评估：0、未审核、1、通过、2、驳回
  name = '' // 昵称
  appealFrom = 0 // 无: 0, 商务：1, 法务/公邮: 2, 涉诉: 3, 网易: 4

  complaintTrackList = [] // 歌单列表
  fileList = [] // 承诺函/通知书
  promiseFile = null
  isFinal = 0 // 标识是否是最终提交

  appealOrder = null // 申诉单号
  applicationType = 0 // 申请类型
  applicationUser = '' // 申请人
  applicationTime = void (0) // 申请时间

  obligeeInfo = {
    personal: new PersonalInfo(),
    agentPersonal: null,
    company: null,
    agentCompany: null
  }

  hasAgent = false // 是否有代理人

  batchOutsideTrackList = { // 外部批量文件
    trackList: [],
    rightFileList: []
  }

  // 非标清单附件
  outsideFileList = []
  outsideFileListNum = 0

  tracklistCount = 0 // 关联歌曲数

  complaintClaim = null // 认领信息

  constructor(initObj) {
    super()

    this._collectProperties()
    if (initObj) {
      this._setValues(initObj)
      this.init(initObj)
    }
  }

  init(initObj) {
    // 调用父类处理合同相关字段
    super.init(initObj)

    if (initObj.complaintTrackList && initObj.complaintTrackList.length) {
      this.complaintTrackList = initObj.complaintTrackList.map(v => new SongList(v))
    }

    // 处理认领信息
    if (initObj.complaintClaim) {
      this.complaintClaim = new CpNotice(initObj.complaintClaim)
    }

    // 处理外部权利人
    if (initObj.obligeeInfo) {
      if (initObj.obligeeInfo.personal) {
        const picList = initObj.obligeeInfo.personal.idPicList
        ;[this.obligeeInfo.personal.idPicList1, this.obligeeInfo.personal.idPicList2] = parseIdPicList(picList)
      }
      if (initObj.obligeeInfo.agentPersonal) {
        const picList = initObj.obligeeInfo.agentPersonal.idPicList
        ;[this.obligeeInfo.agentPersonal.idPicList1, this.obligeeInfo.agentPersonal.idPicList2] = parseIdPicList(picList)
      }
    }

    // 处理非标清单附件
    if (initObj.batchOutsideTrackList) {
      this.outsideFileList = [...this.batchOutsideTrackList.trackList, ...this.batchOutsideTrackList.rightFileList]
      this.outsideFileListNum = this.outsideFileList.length
    }
  }

  /**
   *
   * @override
   * @memberof Complain
   */
  getBackendData() {
    const postData = super.getBackendData()

    if (!postData.promiseFile) {
      delete postData.promiseFile
    }

    postData.complaintTrackList = this.complaintTrackList.map(v => v.getBackendData())

    if (postData.complaintClaim) {
      postData.complaintClaim = this.complaintClaim.getBackendData()
    }

    return postData
  }
}

// 竞品信息
export class CompetitionInfo extends BaseModel {
  competitionFirstTime = '' // 竞品首次投诉日期
  competitionMaxTime = '' // 竞品最新投诉日期
  competitionRemark = '' // 竞品投诉备注
  competitionTrackId = null // 竞品ID
  competitionType = '' // 竞品权利类型 (填字符串)
  competitionUser = '' // 竞品权利人
  id = null
  tracklistId = '' // 关联歌曲ID

  constructor(initObj) {
    super()

    this._collectProperties()
    if (initObj) {
      this._setValues(initObj)
      this.init(initObj)
    }
  }

  init(initObj) {
    super.init(initObj)
  }
}

/* ============= SongList ============= */
export class SongList extends BaseModel {
  tracklistId = null
  meidaType = -1 // 媒体类型：-1 无 0 歌曲 1 mv 2 长音频-单集 3 长音频
  linkId = null // 关联申诉单ID
  trackName = ''
  singerName = ''
  srcVersion = ''
  albumName = ''
  appealTrackId = 0 // 下架/白名单歌曲ID
  appealPlat = 0 // 侵权/下架平台：0、无、1、QQ音乐、2、酷狗音乐、3、酷我音乐、4、懒人听书、5、全民K歌
  appealUrl = '' // 侵权/下架链接
  originTrackId = 0 // 侵权/白名单原歌曲ID
  originTrackName = '' // 侵权/白名单原歌曲名
  originSingerName = '' // 侵权/白名单原歌手名
  originSrcVersion = '' // 侵权/白名单原版本
  originAlbumName = '' // 侵权/白名单原专辑名
  originWordAuthor = '' // 侵权/白名单词作者
  originMusicAuthor = '' // 侵权/白名单曲作者
  originTrackCpCompanyId = 0 // 原曲授权方ID
  originTrackOriginCpCompanyId = 0 // 原曲原始版权方ID
  copyrightFrom = void (0) // 版权开始时间
  copyrightTo = void (0) // 版权结束时间
  wordPercent = 0.0 // 词比例
  musicPercent = 0.0 // 曲比例
  syncToRisk = 0 // 是否同步至高危曲库：0、否，1、是
  location = 0 // 曲序
  trackNumber = '' // 歌曲编码
  discNumber = '' // 专辑编码
  isrc = ''
  upc = ''
  saleTime = void (0)
  tracklistStatus = 0 // 审核状态：0、未审核、1、有效、2、投诉有误、3、权利文件无效
  bussType = 0 // 业务类型：0、侵权投诉、1、下架申请、2、白名单
  isDel = 0 // 是否删除：0、否、1、是

  rightFile = null
  rightFileList = [] // 投诉单详情上传用
  complaintAppeal = new Complaint()
  competitionInfo = new CompetitionInfo()
  create = false // 是否新增

  constructor(initObj) {
    super()

    this.tracklistId = `temp_${uuidv4()}`
    this._collectProperties()
    if (initObj) {
      this._setValues(initObj)
      this.init(initObj)
    }
  }

  init(initObj) {
    // 调用父类处理合同相关字段
    super.init(initObj)

    this.complaintAppeal = new Complaint(initObj.complaintAppeal)
    this.competitionInfo = new CompetitionInfo(initObj.competitionInfo)

    this.showTmeId = this.appealTrackId
    this.originInfo = {
      showTmeId: initObj.originTrackId,
      trackName: initObj.originTrackName,
      singerName: initObj.originSingerName,
      srcVersion: initObj.originSrcVersion,
      albumName: initObj.originAlbumName,
      wordAuthor: initObj.originWordAuthor,
      musicAuthor: initObj.originMusicAuthor,
    }
  }

  /**
   *
   * @override
   * @memberof Complain
   */
  getBackendData() {
    const postData = super.getBackendData()
    if (postData.create) {
      postData.tracklistId = null
    }

    if (postData.rightFileList.length) {
      postData.rightFile = postData.rightFileList[0]
    }

    return postData
  }
}

/* ============= MatchList ============= */
export class MatchList extends BaseModel {
  pkId = null
  tmeId = 0
  audioType = 0 // 媒体类型：0 歌曲 1 mv 2 长音频-单集 3 长音频 4 专辑
  pkStatus = 0 // 审核状态：0、匹配时无权、1、未反馈、2、已撤诉、3、放弃、4、申诉挂起、5、申诉驳回
  createType = 0 // 创建方式：0、人工、1、复用
  createId = '' // 创建来源
  linkId = 0 // 关联歌单ID
  expiresTime = void (0) // 期限
  matchTrackName = '' // 匹配歌曲名
  matchAlbumName = '' // 匹配专辑名
  matchCompanyName = '' // 匹配公司名
  matchOriginCompanyName = '' // 匹配原始公司名
  matchSingerName = '' // 匹配歌手名
  matchSrcVersion = '' // 匹配版本

  complaintTrackList = new SongList()

  platId = '' // 匹配时平台 ID
  platStatus = void 0 // 平台状态
  cpStatus= void 0 // 匹配时版权状态
  historyCompany = '' // 匹配时版权公司(填ID)
  historyOriginCompany='' // 匹配时原始版权公司(填ID)
  remark= '' // 备注
  operateUser= '' // 经办人
  legalAffairs = '' // 法务意见

  confirmRightFileInfo = null // 确权文件

  rightFileList = [] // 确权文件列表

  constructor(initObj) {
    super()

    this._collectProperties()
    if (initObj) {
      this._setValues(initObj)
      this.init(initObj)
    }
  }

  init(initObj) {
    // 调用父类处理合同相关字段
    super.init(initObj)

    this.complaintTrackList = new SongList(initObj.complaintTrackList)
    this.complaintTrackList.complaintAppeal = new Complaint(initObj.complaintAppeal)
    // 把歌单信息提到外面
    Object.defineProperties(this, Object.keys(this.complaintTrackList).reduce((res, key) => {
      if (!['id', 'linkId', 'insertTime', 'modifyTime'].includes(key)) {
        res[key] = {
          value: this.complaintTrackList[key],
          enumerable: true,
          writable: true
        }
      }

      return res
    }, {}))

    this.matchInfo = {
      showTmeId: initObj.tmeId,
      trackName: initObj.matchTrackName,
      singerName: initObj.matchSingerName,
      srcVersion: initObj.matchSrcVersion,
      albumName: initObj.matchAlbumName,
      meidaType: initObj.audioType
    }

    // 处理确权文件
    if (initObj.confirmRightFileInfo && initObj.confirmRightFileInfo.id) {
      this.rightFileList = [{
        ...initObj.confirmRightFileInfo,
        name: initObj.confirmRightFileInfo.fileName,
        url: initObj.confirmRightFileInfo.fileUrl
      }]
    }
  }

  /**
   *
   * @override
   * @memberof Complain
   */
  getBackendData() {
    const postData = super.getBackendData()

    // 如果为空，设置为0
    if (postData.platId === '') {
      postData.platId = 0
    }

    return postData
  }
}

/* ============= SubComplaint ============= */
export class SubComplaint extends BaseModel {
  id = null
  appealId = null // 子单关联父单ID
  subApplicationOrder = null // 子申诉单号
  appealOrder = null // 申诉父单号
  appealTitle = '' // 申诉名称
  companyId = 0 // 公司ID
  subStatus = 0
  subInsertTime = void (0)
  subModifyTime = void (0)
  expiresTime = void (0) // 最新确权时间
  operateUser = '' // 当前操作人
  complaintType = 0
  bussType = 0
  applicationType = 0
  appealOrder = null
  applicationTime = void (0)
  applicationUser = ''
  tracklistCount = 0

  companyList = null // 授权方
  authorizer = ''

  constructor(initObj) {
    super()

    this._collectProperties()
    if (initObj) {
      this._setValues(initObj)
      this.init(initObj)
    }
  }

  init(initObj) {
    super.init(initObj)

    // 把公司列表处理成授权方文本，用中文逗号分隔
    if (initObj.companyList && initObj.companyList.length) {
      this.authorizer = initObj.companyList.map(v => v.companyName).join('，')
    }
  }
}
